export class Reasons {
  public reasons?: Reason[]

  constructor(reasons?: Reason[]) {
    this.reasons = reasons
  }
}

export class Reason {
  public reasonId?: string
  public reason?: string
  public isShipment?: boolean
  public isPackage?: boolean
  public isCustomer?: boolean
  public isCourier?: boolean
  public isShop?: boolean
  public isIndopaket?: boolean
  public isDropOff?: boolean
  public isPickUpCod?: boolean
  public isDropOffCod?: boolean
  public isPickUp?: boolean
  public isTransferTaskPickup?: boolean
  public isTransferTaskDelivery?: boolean
  public isPickupOutsideRadius?: boolean
  public isPickUpFavorite?: boolean
  public isDropOffFavorite?: boolean
  public isCodReject?: boolean
  public whatsappTemplate?: string

  constructor(
    reasonId?: string,
    reason?: string,
    isShipment?: boolean,
    isPackage?: boolean,
    isCustomer?: boolean,
    isCourier?: boolean,
    isShop?: boolean,
    isIndopaket?: boolean,
    isDropOff?: boolean,
    isPickUpCod?: boolean,
    isDropOffCod?: boolean,
    isPickUp?: boolean,
    isTransferTaskPickup?: boolean,
    isTransferTaskDelivery?: boolean,
    isPickupOutsideRadius?: boolean,
    isPickUpFavorite?: boolean,
    isDropOffFavorite?: boolean,
    isCodReject?: boolean,
    whatsappTemplate?: string
  ) {
    this.reasonId = reasonId
    this.reason = reason
    this.isShipment = isShipment
    this.isPackage = isPackage
    this.isCustomer = isCustomer
    this.isCourier = isCourier
    this.isShop = isShop
    this.isIndopaket = isIndopaket
    this.isDropOff = isDropOff
    this.isPickUpCod = isPickUpCod
    this.isDropOffCod = isDropOffCod
    this.isPickUp = isPickUp
    this.isTransferTaskPickup = isTransferTaskPickup
    this.isTransferTaskDelivery = isTransferTaskDelivery
    this.isPickupOutsideRadius = isPickupOutsideRadius
    this.isPickUpFavorite = isPickUpFavorite
    this.isDropOffFavorite = isDropOffFavorite
    this.isCodReject = isCodReject
    this.whatsappTemplate = whatsappTemplate
  }
}
